var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.585,
    height: 31.215,
    viewBox: "0 0 30.585 31.215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .search {\n        fill: none;\n        stroke: #16151a;\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    transform: "translate(-880.5 -64.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    transform: "translate(-165.204 -130.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    transform: "translate(1046 195.187)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    className: "search",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(0.204 0.338)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    className: "search",
    d: "M1067,219.646l5.519,5.35a1.976,1.976,0,0,0,2.794-2.8l-5.35-5.518",
    transform: "translate(-0.254 0.014)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    transform: "translate(1050.943 202.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    className: "search",
    d: "M1053.03,212.509a6.911,6.911,0,0,1,0-9.778",
    transform: "translate(-1051.004 -202.731)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.626e797f874cdf0eeb2dbdc7a2ee6ca0.svg";
export { ForwardRef as ReactComponent };